import { Link } from 'gatsby'
import React from 'react'
import { getContentfulImageURL } from '../../../lib/helpers'
import CategoryTag from '../General/CategoryTag'

const ArticleImageLink = ({data, textColor = "black"}) => {
    if (!data) return null
    
    const season = data.sys?.contentType?.sys?.id === "articleV2" ? "Season 2" : "Season 1"

    return (
        <div className='image-container'>
            <Link to={`/${data.category.toLowerCase()}/${data.slug}/`}>
                <div className='article-image-link'>
                        <div className="article-details">
                            <CategoryTag>{data.category}</CategoryTag>
                            <CategoryTag>{season}</CategoryTag>
                        </div>
                        <img src={getContentfulImageURL(data.listViewImage?.file?.url, 1000, 85)} alt="" />


                </div>
            </Link>
            <div className='title-container'>
                <h5 className="article-title elizeth">{data.title}</h5>
            </div>

            <style jsx>{`
                .image-container {
                    width: 100%;
                }
                
                .article-image-link {
                    display: block;
                    width: 100%;
                    height: 0;
                    padding-bottom: 110%;
                    // width: 400px;
                    // height: 500px;
                    position: relative;
                    overflow: hidden;
                    border-radius: 15px;
                }

                .article-details {
                    position: absolute;
                    bottom: 0px;
                    left: 0px;
                    z-index: 1;
                    padding: 20px;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    grid-gap: 10px;
                    
                }
                .title-container {
                    padding: 20px;
                }

                .article-title {
                    color: ${textColor};
                    font-size: 32px;
                }
                img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    z-index: 0;
                }

            `}</style>
        </div>


    )
}


export default ArticleImageLink

